'use client';

import React from 'react';

export default function SliderToggleTake({ activeTab, setActiveTab }) {
  const handleKeyDown = (e, tab) => {
    // Allow selection with Space or Enter keys
    if (e.key === ' ' || e.key === 'Enter') {
      e.preventDefault(); // Prevent page scroll
      setActiveTab(tab);
    }
  };

  return (
    <div className="slider-toggle-container" role="radiogroup" style={{ margin: '0 auto' }} data-qa="take-type-toggle">
      <div
        role="radio"
        aria-checked={activeTab === 'voice'}
        tabIndex={0} // Makes the div focusable
        className={`slider-option ${activeTab === 'voice' ? 'active' : ''}`}
        onClick={() => setActiveTab('voice')}
        onKeyDown={(e) => handleKeyDown(e, 'voice')}
        data-qa="take-type-voice-option"
      >
        Voice
      </div>
      <div
        role="radio"
        aria-checked={activeTab === 'text'}
        tabIndex={0} // Makes the div focusable
        className={`slider-option ${activeTab === 'text' ? 'active' : ''}`}
        onClick={() => setActiveTab('text')}
        onKeyDown={(e) => handleKeyDown(e, 'text')}
        data-qa="take-type-text-option"
      >
        Text
      </div>
      <div className={`slider-background ${activeTab === 'text' ? 'on' : 'off'}`} data-qa="take-type-indicator"></div>
    </div>
  );
}
